import commonUtils from "../../utils/common.utils";
import OrderSpecsModel from "../orderSpecs.model";
import ComboSpecsModel from "../comboSpecs.model";

export default class OrderGoods {
    constructor(data) {
        this.id = commonUtils.generateId();
        this.orderCount =  data.orderGood.quantity;
        this.vipLevel = data.vipLevel;
        if (data.orderGood.note) {
            this.note = data?.orderGood?.note || ''
        }

        if (!data.orderGood.isCombo) {
            this.product = data.orderGood.product;
            this.orderSpecs = data.orderGood.settings.map(setting => new OrderSpecsModel(setting));
        } else {
            const combo = new ComboSpecsModel(data.orderGood);
            this.combo = data.orderGood.product;
            this.orderProducts = combo.fixedProducts;
            this.orderComboSubs = combo.orderComboSubs;
            this.orderComboSubAny = combo.orderComboSubAny;
            this.cleanComboSettings(data.orderGood.product.comboSubSettings);
        }
    }

    cleanComboSettings(comboSubSettings) {
        comboSubSettings.forEach(group => {
            delete group.productSelectCount;
            delete group.allProducts;
            delete group.products;
            delete group.markUpProducts;
        });
    }
}